// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"77d5de5e","934":"cfe620c0"}[chunkId] + ".js";
};